import styled, { css } from "styled-components";

export const Container = styled.div`
  padding-top: 25px;

  div,
  p,
  span {
    color: ${({ theme }) => theme.colors.textColor};
  }

  img {
    width: 100%;
  }
`;
